// extracted by mini-css-extract-plugin
module.exports = {"moreItem":"style_moreItem__yPQqI","moreItem-icon":"style_moreItem-icon__aZz6x","moreItem-text":"style_moreItem-text__ZhiQp"};